// extracted by mini-css-extract-plugin
export default {"ERPIntroduction":"ERPIntroduction_ERPIntroduction__Wf6CW"};